import { AutosuggestModel } from './Models/ffAutosuggestModel';
import { setDummyImage } from '../../scripts/functions.js';
import { availabilityStatusFilter } from './Models/ffConstants';
import { factfinderSuggestTracking } from './Tracking/factFinderTracking';
import { closeSuggest } from './defaultSuggest';
import { isSafeUrl } from '../Shared/UrlSafety';

$(() => {
    /**
     * Ab 3 Zeichen (ohne Leerzeichen) soll dem Kunden ein Autosuggest-Vorschlag gemacht werden
     */
    $('.mainSearchInput').on('input', function() {
        var query = ($(this).val() + '').trim();
        if (query !== '') {
            $(this)
                .closest('.inputEls')
                .find('.eraseSearchTerm')
                .removeClass('hide');
        }
        if (query == '') {
            $(this)
                .closest('.inputEls')
                .find('.eraseSearchTerm')
                .addClass('hide');
        }
        if (query !== '' && query.length > 2) {
            getAutoSuggestResults($(this).val());
        } else if (query == '' || query.length < 3) {
            $('.autoSuggest').removeClass('autoSuggest-container');
        }

        var changeCurIcon = $('.showMoreSubjects').children('i.fa');
        if ($(changeCurIcon).hasClass('fa-angle-up')) {
            $(changeCurIcon)
                .removeClass('fa-angle-up')
                .addClass('fa-angle-down');
            $('.moreSubjects').hide(0);
        }
    });

    $('.autoSuggest').on('click', '.suggest-tracking', function() {
        const area = $(this).data('area') as string;

        if (area) {
            factfinderSuggestTracking(area);
        }
    });

    /**
     * Fragt die Daten vom Controller ab
     * @param query
     */
    function getAutoSuggestResults(query) {
        $.get('/umbraco/api/FfAutosuggest/GetSuggest?query=' + query, data => {
            var model = data as AutosuggestModel;
            clearSuggests();
            if (model != null && model.suggestions != null && model.suggestions.length > 0) {
                var displaysElements: boolean = fillSuggestContainer(model, query);
                if (displaysElements) {
                    $('.autoSuggest').addClass('autoSuggest-container');
                } else {
                    $('.autoSuggest').removeClass('autoSuggest-container');
                }
            } else {
                $('.autoSuggest').removeClass('autoSuggest-container');
            }
        });
    }

    /**
     * Füllt das Autosuggest-Overlay aus dem Model
     * @param model
     * @param query
     */
    function fillSuggestContainer(model: AutosuggestModel, query): boolean {
        let displaysElements = false;
        var hiddenSuggestElements = $('#hiddenSuggestElements');
        let productResultsCount = 0;
        const originalQuery = query;
        query = capitalize(query);
        for (let suggestion of model.suggestions) {
            if (suggestion.type === 'searchTerm') {
                //Kopiert das Suchvorschlag-Element
                var suchvorschlag = hiddenSuggestElements.find('.Suchvorschlag').clone();
                suchvorschlag.find('a').attr('role', 'option');
                //Bringt die Usersuche un das selbe Format wie die Antwort von FF
                var searchquery = umlauteAnpassen(query).toUpperCase();
                //Füllt den suggest, hängt es dem passenden Container an und zeigt den Container an.
                if (suggestion.name != null) {
                    var markedSuggest = markSuggest(suggestion.name, searchquery);
                    suchvorschlag.find('a').attr('href', `/suche?query=${suggestion.name}&userInput=${query}`);
                    var span = hiddenSuggestElements.find('#SuggestElementsToClone span').clone();
                    span.html(markedSuggest);
                    suchvorschlag.find('a').append(span);
                    $('.Suchvorschlaege').not('.defaultSuggest *').find('.suggestItems').append(suchvorschlag);
                    $('.Suchvorschlaege').not('.defaultSuggest *').show();
                    displaysElements = true;
                }
            } else if (suggestion.type === 'category') {
                var category = hiddenSuggestElements.find('.Kategorievorschlag').clone();
                category.find('a').attr('role', 'option');
                if (suggestion.name != null) {
                    var formattedQuery = umlauteAnpassen(query).toUpperCase();
                    var markedCategory = markSuggest(suggestion.name, formattedQuery);
                    if (suggestion.attributes.deeplink && isSafeUrl(suggestion.attributes.deeplink)) {
                        category.find('a').attr('href', suggestion.attributes.deeplink);
                    }
                    var spanCategory = hiddenSuggestElements.find('#SuggestElementsToClone span').clone();
                    spanCategory.html(markedCategory);
                    category.find('a').append(spanCategory);
                    $('.Kategorievorschlaege').not('.defaultSuggest *').find('.suggestItems').append(category);
                    $('.Kategorievorschlaege').not('.defaultSuggest *').show();
                    displaysElements = true;
                }
            } else if (suggestion.type === 'Service') {
                //Kopiert das Servicevorschlag-Element
                var servicethema = hiddenSuggestElements.find('.Servicethema').clone();
                servicethema.find('a').attr('role', 'option');
                //Füllt den suggest, hängt es dem passenden Container an und zeigt den Container an.
                if (suggestion.name != null) {
                    var markedSuggestThema = markSuggest(suggestion.name, query);
                    var spanThema = hiddenSuggestElements.find('#SuggestElementsToClone span').clone();
                    servicethema.find('a').attr('href', '/suche?query=' + suggestion.name);
                    spanThema.html(markedSuggestThema);
                    servicethema.find('a').append(spanThema);
                    $('.Servicethemen').not('.defaultSuggest *').find('.suggestItems').append(servicethema);
                    $('.Servicethemen').not('.defaultSuggest *').show();
                    displaysElements = true;
                }
            } else if (suggestion.type === 'productName') {
                if (
                    availabilityStatusFilter.includes(suggestion.attributes.availabilityStatusId) &&
                    productResultsCount < 3
                ) {
                    productResultsCount++;
                    //Kopiert das Titelvorschlag-Element
                    var titelvorschlag = hiddenSuggestElements.find('.Titelvorschlag').clone();
                    titelvorschlag.attr('role', 'option');
                    //Füllt den suggest, hängt es dem passenden Container an und zeigt den Container an.
                    titelvorschlag.find('.title').html(suggestion.name != null ? suggestion.name : '');

                    if (suggestion.image != null) {
                        var widthParam = suggestion.image.indexOf('&width=56');
                        if (widthParam > 0) {
                            suggestion.image = suggestion.image.replace('&width=56', '');
                        }
                        suggestion.image = suggestion.image + '&height=80';
                    }
                    titelvorschlag
                        .find('img')
                        .attr('src', suggestion.image != null ? suggestion.image : '')
                        .on('error', function() {
                            setDummyImage(this);
                        });
                    if (suggestion.attributes != null) {
                        const fallbackHref = `/product/${suggestion.attributes.id}`;
                        const safeHref = suggestion.attributes.deeplink && isSafeUrl(suggestion.attributes.deeplink)
                            ? suggestion.attributes.deeplink
                            : fallbackHref;
                        titelvorschlag.attr('href', safeHref);
                        titelvorschlag
                            .find('.author')
                            .html(
                                suggestion.attributes.urheberzeile != null
                                    ? markSuggest(suggestion.attributes.urheberzeile, query)
                                    : ''
                            );
                        titelvorschlag
                            .find('.volume')
                            .html(
                                suggestion.attributes.auflage != null
                                    ? markSuggest(suggestion.attributes.auflage, query)
                                    : ''
                            );
                    }
                    $('.Titelvorschlaege').not('.defaultSuggest *').find('.suggestItems').append(titelvorschlag);
                    $('.Titelvorschlaege').not('.defaultSuggest *').show();
                    displaysElements = true;
                }
            }
        }

        if (productResultsCount === 0) {
            $('.allSearchResultsLink').hide();
        } else {
            $('.allSearchResultsLink').show();
            $('.allSearchResultsLink').attr('href', `/suche?query=${originalQuery}`);
        }

        return displaysElements;
    }

    /**
     * markiert die gesuchten wörter im suchvorschlag
     * @param suggestion
     * @param searchquery
     */
    function markSuggest(suggestion, searchquery) {
        var re = new RegExp(searchquery.replace(/ /g, '|'), 'gi');

        return suggestion.replace(re, function(matched) {
            return '<span class="red">' + matched + '</span>';
        });
    }

    /**
     * Löscht die Vorschläge.
     * .not('.defaultSuggest *') scopes the wipes/hides to live-suggest blocks
     * only — without it, the cloned items inside .defaultSuggest get nuked too.
     */
    function clearSuggests() {
        $('.suggestItems').not('.defaultSuggest *').html('');
        $('.Suchvorschlaege').not('.defaultSuggest *').hide();
        $('.Servicethemen').not('.defaultSuggest *').hide();
        $('.Kategorievorschlaege').not('.defaultSuggest *').hide();
        $('.Titelvorschlaege').not('.defaultSuggest *').hide();
    }

    /**
     * Passt die Umlaute in einem String an. zB ä => ae
     * @param query
     */
    function umlauteAnpassen(query) {
        return query
            .replace(/\u00e4/g, 'ae')
            .replace(/\u00c4/g, 'Ae')
            .replace(/\u00fc/g, 'ue')
            .replace(/\u00dc/g, 'Ue')
            .replace(/\u00f6/g, 'oe')
            .replace(/\u00d6/g, 'Oe');
    }

    function capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    }
});
/**
 * Lässt das Suggestfenster verschwinden, wenn man danaben klickt
 */
$(document).mouseup(e => {
    var container_01 = $('.autoSuggest');

    if (e.target instanceof Element) {
        // Clicking the search input itself focuses it and triggers openDefaultSuggest;
        // don't immediately re-close on the same click's mouseup.
        const clickedSearchInput = $(e.target).closest('.mainSearchInput').length > 0;

        // if the target of the click isn't the container nor a descendant of the container
        if (!clickedSearchInput && container_01.has(e.target).length === 0 && !container_01.is(e.target)) {
            closeSuggest();
        }
    }
    CloseDropDownWindows(e);
});

function CloseDropDownWindows(e) {
    var container_02 = $('.showMoreSubjects');
    if (!container_02.is(e.target) && container_02.has(e.target).length === 0) {
        //container_02.hide();
        var changeCurIcon = $(container_02).children('i.fa');
        if ($(changeCurIcon).hasClass('fa-angle-up')) {
            $(changeCurIcon)
                .removeClass('fa-angle-up')
                .addClass('fa-angle-down');
            $('.moreSubjects').hide(0);
            $('.moreSubjectsTestContainer').hide(0);
        }
    }
    const container_03 = $('.basket-menu-bubble');
    if (!container_03.is(e.target) && container_03.has(e.target).length === 0) {
        container_03.hide();
    }
}
